export const idAndRefFields = {
  idField: 'id',
  refField: 'ref',
};
